import ContactsAPI from 'media-base-ui/utils/contactsAPI';
import actionCreators from './actionCreators';

const fetchContactsData = () => async dispatch => {
    dispatch(actionCreators.requestAllContactsData());

    try {
        const data = await ContactsAPI.fetchContactsByTeamAndRankData();
        dispatch(actionCreators.contactsDataResponse(true, data, null));
    } catch (error) {
        dispatch(actionCreators.contactsDataResponse(false, [], error));
    }
};

export default {
    fetchContactsData
}
